import getCountryPrefix from 'Jsx/Utils/getCountryPrefix';

const useLocalCurrency = () => {
  const countryPrefix = getCountryPrefix();

  const localCurrencyCodes = ['pe', 'ar', 'mx', 'co', 'es', 'cl', 'br'];

  const hasLocalCurrency = localCurrencyCodes.includes(countryPrefix);

  return { localCurrencyCodes, hasLocalCurrency };
};

export default useLocalCurrency;
